import React from 'react';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Section } from '../components/Section';
import { MomentFormat, utcToLocalFormat } from '../plugins/moment';
import { fetcher } from '../plugins/react-query';
import { Notice } from '../types';

export const NoticePage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: notice } = useQuery<Notice>(`/notices/${id}`, fetcher);

  if (!notice) {
    return <></>;
  }

  return (
    <Section className="max-w-3xl">
      <h1 className="text-24 font-bold capitalize break-all">{notice.title}</h1>
      <time className="text-15 text-gray-500 mb-8">
        {utcToLocalFormat(notice.createdAt, MomentFormat.LL)}
      </time>
      <FroalaEditorView model={notice.context} />
    </Section>
  );
};
